import { cn } from '@/lib/utils';

/** Bouton primaire institution (or Stratelya). */
export const btnPrimaryInstClass = cn(
  'bg-[color:var(--inst-player-accent,#B38E5D)] text-white shadow-sm',
  'hover:brightness-110 active:brightness-95',
  'focus-visible:ring-[color:var(--inst-player-accent,#B38E5D)]',
);

/** Bouton secondaire / accent or institution. */
export const btnSecondaryInstClass = cn(
  'bg-[color:var(--inst-player-accent,#B38E5D)] text-white',
  'hover:brightness-110 active:brightness-95',
  'focus-visible:ring-[color:var(--inst-player-accent,#B38E5D)]',
);

/** Bouton contour institution (bordure or Stratelya). */
export const btnOutlineInstClass = cn(
  'border border-[#B38E5D] bg-white text-[#001B3D]',
  'hover:bg-[#FDFBF7] hover:border-[#B38E5D]',
  'focus-visible:ring-[#B38E5D]',
);

/** Bouton fantôme institution. */
export const btnGhostInstClass = cn(
  'bg-transparent text-[color:var(--inst-player-text,#001B3D)]',
  'hover:bg-[color:color-mix(in_srgb,var(--inst-player-primary,#001B3D)_8%,transparent)]',
  'dark:text-[#EDE6DC] dark:hover:bg-[hsl(217,33%,17%)]',
  'focus-visible:ring-[color:var(--inst-player-primary,#001B3D)]',
);

/** Bouton neutre (surface crème). */
export const btnDefaultInstClass = cn(
  'bg-[#F0EBE3] text-[color:var(--inst-player-text,#001B3D)]',
  'hover:bg-[#E5DDD2]',
  'dark:bg-[hsl(217,33%,20%)] dark:text-[#EDE6DC] dark:hover:bg-[hsl(217,33%,24%)]',
  'focus-visible:ring-[color:var(--inst-player-primary,#001B3D)]',
);

/** Lien bouton institution. */
export const btnLinkInstClass = cn(
  'text-[color:var(--inst-player-primary,#001B3D)]',
  'dark:text-[color:var(--inst-player-link,#E8D5BC)]',
);
